module.exports = __webpack_public_path__ + "img/step5-c.c093fd3a.png";